var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("VAutocomplete", {
    staticClass: "df-autocomplete",
    attrs: {
      label: _vm.schema.label,
      "allow-overflow": false,
      hint: _vm.schema.hint,
      "item-text": _vm.schema.itemText,
      "item-value": _vm.schema.itemValue,
      items: _vm.schema.items,
      placeholder: _vm.schema.placeholder,
      rules: _vm.rules
    },
    scopedSlots: _vm._u([
      {
        key: "append",
        fn: function() {
          return [
            _c("NsIcon", {
              attrs: {
                "icon-name": "icon-chevron-down",
                height: "20",
                width: "20"
              }
            })
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.model,
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }